import React from 'react';
import { Knowledge } from '@axtria/hqi-configurator';
import '@axtria/hqi-configurator/lib/hqi-configurator.css';
import { useSelector } from 'react-redux';
import './knowledge.scss';
const baseURL = process.env.REACT_APP_HQI_BASE_URL
const ws_baseURL = process.env.REACT_APP_HQI_BASE_WEBSOCKET_URL
const UMUrl = process.env.REACT_API_URL


interface KnowledgeComponentProps {
  mainView?: string;
}

const KnowledgeComponent: React.FC<KnowledgeComponentProps> = ({ mainView }) => {
  const { userInfo } = useSelector((state: any) => ({
    userInfo: state.loginResource,
  }));

  const getPreferredProjectName = (data: any) => {
    const company = data.company_data.find((c: any) => c.companyId === data.preferredCompany);
    if (!company) return null;

    const project = company.projectList.find((p: any) => p.project_id === data.preferredProject);
    return project ? project.project_name : null;
  };

  return (
    <div className="knowledge-container">
      {userInfo?.preferredProject ? (
        <Knowledge
          key={`${userInfo.preferredProject}-${mainView || 'default'}`}
          DOMAIN={baseURL}
          WS_DOMAIN={ws_baseURL}
          USER_ID={65}
          PROJECT_ID={userInfo.preferredProject}
          PROJECT_NAME={getPreferredProjectName(userInfo)}
          DOMAIN_UM={UMUrl}
          mainView={mainView}
        />
      ) : (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          fontSize: '18px',
          color: '#666'
        }}>
          Please select a project to view the Knowledge Center
        </div>
      )}
    </div>
  );
};

export default KnowledgeComponent;
